/*Import Estilo*/
import './index.scss';
import '../../../../css/global.css';
import '../../../../css/normalize.css';

/*Import Bibliotecas*/
import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/*Import Componentes*/
import Cabecalho from '../../../../components/Cabecalho';
import Rodape from '../../../../components/Rodape';
import CookieAceite from '../../../../components/CookieAceite';
import MenuLateral from '../../../../components/MenuLateral';
import BtnVoltar from '../../../../components/bntVoltar';

/*Import Requisição API*/
import api from '../../../../api';

import { NumericFormat } from 'react-number-format';
import CurrencyInput from 'react-currency-input-field';
import axios from 'axios';
import { useToast } from '../../../../context/ToastContext';

export default function CadastroProduto() {
    const [produto, setProduto] = useState({
        nome: '',
        descricao: '',
        descricaoLonga: '',
        codigoBarras: '',
        marca: '',
        status: 'ativo',
        idCategoria: '',
        idFornecedor: '',
        variacoes: [
            {
                tamanho: '',
                cor: '',
                material: '',
                tipo: '',
                unidades_por_pacote: 1,
                preco_compra: 0,
                preco_varejo: 0,
                preco_atacado: 0,
                estoque: 0,
                sku: '',
                peso: 0,
                altura: 0,
                largura: 0,
                profundidade: 0,
                imagens: []
            }
        ]
    });

    // Carregar produto e dados adicionais
    const [loading, setLoading] = useState(false);

    const { showToast } = useToast();

    const [draggedImage, setDraggedImage] = useState(null);

    const [id, setIdUsuario] = useState('');

    const navigate = useNavigate();

    /* Dialog de avisos gerais */
    const CaixaDeDialogoAviso = useRef(null);
    const [modalAbertoAviso, setModalAbertoAviso] = useState(false);
    const [texto, setTexto] = useState("");

    /* Modal de Categoria */
    const CaixaModalCategoria = useRef(null);
    const [modalCategoriaAberto, setModalCategoriaAberto] = useState(false);
    const [novaCategoria, setNovaCategoria] = useState({
        nome: '',
        descricao: '',
        id_categoria_pai: ''
    });

    /* Modal de Fornecedor */
    const CaixaModalFornecedor = useRef(null);
    const [modalFornecedorAberto, setModalFornecedorAberto] = useState(false);
    const [novoFornecedor, setNovoFornecedor] = useState({
        nome: '',
        cnpj: '',
        telefone: '',
        email: '',
        site: '',
        contato_nome: '',
        contato_email: '',
        cep: '',
        logradouro: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: ''
    });

    useEffect(() => {
        CaixaDeDialogoAviso.current = document.getElementById("CaixaDeDialogoAviso");
        CaixaModalCategoria.current = document.getElementById("CaixaModalCategoria");
        CaixaModalFornecedor.current = document.getElementById("CaixaModalFornecedor");
    }, []);

    const abrirModalAviso = () => {
        if (CaixaDeDialogoAviso.current) {
            CaixaDeDialogoAviso.current.showModal();
        }
    };

    const fecharModalAviso = () => {
        setModalAbertoAviso(false);
        CaixaDeDialogoAviso.current?.close();
    };

    /* Funções do Modal de Categoria */
    const abrirModalCategoria = () => {
        setNovaCategoria({ nome: '', descricao: '', id_categoria_pai: '' });
        setModalCategoriaAberto(true);
        if (CaixaModalCategoria.current) {
            CaixaModalCategoria.current.showModal();
        }
    };

    const fecharModalCategoria = () => {
        setModalCategoriaAberto(false);
        setNovaCategoria({ nome: '', descricao: '', id_categoria_pai: '' });
        CaixaModalCategoria.current?.close();
    };

    const salvarCategoria = async (e) => {
        e.preventDefault();
        
        if (!novaCategoria.nome.trim()) {
            setTexto('O nome da categoria é obrigatório.');
            abrirModalAviso();
            return;
        }

        try {
            const response = await api.post('/categorias', {
                nome: novaCategoria.nome,
                descricao: novaCategoria.descricao,
                id_categoria_pai: novaCategoria.id_categoria_pai || null,
                usuario_id: id
            });

            if (response.data.success) {
                // Atualizar lista de categorias
                const categoriasResponse = await api.get('/listarcategorias');
                setCategorias(categoriasResponse.data.categorias);
                
                // Selecionar automaticamente a nova categoria
                setProduto({ ...produto, idCategoria: response.data.id.toString() });
                
                showToast('Categoria cadastrada com sucesso!', 'success');
                fecharModalCategoria();
            }
        } catch (error) {
            console.error('Erro ao cadastrar categoria:', error);
            setTexto(error.response?.data?.message || 'Erro ao cadastrar categoria.');
            abrirModalAviso();
        }
    };

    /* Funções do Modal de Fornecedor */
    const abrirModalFornecedor = () => {
        setNovoFornecedor({ 
            nome: '', cnpj: '', telefone: '', email: '', site: '', 
            contato_nome: '', contato_email: '', cep: '', logradouro: '', 
            numero: '', complemento: '', bairro: '', cidade: '', estado: '' 
        });
        setModalFornecedorAberto(true);
        if (CaixaModalFornecedor.current) {
            CaixaModalFornecedor.current.showModal();
        }
    };

    const fecharModalFornecedor = () => {
        setModalFornecedorAberto(false);
        setNovoFornecedor({ 
            nome: '', cnpj: '', telefone: '', email: '', site: '', 
            contato_nome: '', contato_email: '', cep: '', logradouro: '', 
            numero: '', complemento: '', bairro: '', cidade: '', estado: '' 
        });
        CaixaModalFornecedor.current?.close();
    };

    const formatarCNPJ = (valor) => {
        const numeros = valor.replace(/\D/g, '');
        if (numeros.length <= 14) {
            return numeros.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
        }
        return valor;
    };

    const formatarTelefone = (valor) => {
        const numeros = valor.replace(/\D/g, '');
        if (numeros.length <= 10) {
            return numeros.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
        } else if (numeros.length <= 11) {
            return numeros.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
        }
        return valor;
    };

    const formatarCEP = (valor) => {
        const numeros = valor.replace(/\D/g, '');
        return numeros.replace(/^(\d{5})(\d{3})$/, '$1-$2').slice(0, 9);
    };

    const buscarEnderecoPorCep = async (cep) => {
        const cepLimpo = cep.replace(/\D/g, '');
        if (cepLimpo.length !== 8) return;
        
        try {
            const response = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`);
            const data = await response.json();
            if (!data.erro) {
                setNovoFornecedor(prev => ({
                    ...prev,
                    logradouro: data.logradouro || '',
                    bairro: data.bairro || '',
                    cidade: data.localidade || '',
                    estado: data.uf || ''
                }));
            }
        } catch (error) {
            console.error('Erro ao buscar CEP:', error);
        }
    };

    const salvarFornecedor = async (e) => {
        e.preventDefault();
        
        if (!novoFornecedor.nome.trim()) {
            setTexto('O nome do fornecedor é obrigatório.');
            abrirModalAviso();
            return;
        }

        if (!novoFornecedor.cnpj.trim()) {
            setTexto('O CNPJ é obrigatório.');
            abrirModalAviso();
            return;
        }

        if (!novoFornecedor.email.trim()) {
            setTexto('O e-mail é obrigatório.');
            abrirModalAviso();
            return;
        }

        if (!novoFornecedor.cep.trim()) {
            setTexto('O CEP é obrigatório.');
            abrirModalAviso();
            return;
        }

        try {
            const cnpjLimpo = novoFornecedor.cnpj.replace(/\D/g, '');
            const telefoneLimpo = novoFornecedor.telefone.replace(/\D/g, '');
            const cepLimpo = novoFornecedor.cep.replace(/\D/g, '');

            const response = await api.post('/fornecedores', {
                fornecedor: {
                    nome: novoFornecedor.nome,
                    cnpjcpf: cnpjLimpo,
                    telefone: telefoneLimpo,
                    email_contato: novoFornecedor.email,
                    site: novoFornecedor.site,
                    nome_contato: novoFornecedor.contato_nome,
                    email_contato_secundario: novoFornecedor.contato_email
                },
                endereco: {
                    cep: cepLimpo,
                    logradouro: novoFornecedor.logradouro,
                    numero: novoFornecedor.numero,
                    complemento: novoFornecedor.complemento,
                    bairro: novoFornecedor.bairro,
                    cidade: novoFornecedor.cidade,
                    estado: novoFornecedor.estado
                },
                usuario_id: id
            });

            if (response.data.success) {
                // Atualizar lista de fornecedores
                const fornecedoresResponse = await api.get('/listarfornecedores');
                setFornecedores(fornecedoresResponse.data.fornecedores || []);
                
                // Selecionar automaticamente o novo fornecedor
                setProduto({ ...produto, idFornecedor: response.data.id_fornecedor.toString() });
                
                showToast('Fornecedor cadastrado com sucesso!', 'success');
                fecharModalFornecedor();
            }
        } catch (error) {
            console.error('Erro ao cadastrar fornecedor:', error);
            setTexto(error.response?.data?.message || 'Erro ao cadastrar fornecedor.');
            abrirModalAviso();
        }
    };

    useEffect(() => {
        const buscarDadosUsuario = async () => {
            try {
                const response = await api.get('/usuario', { withCredentials: true });
                console.log("Resposta da API:", response.data);

                if (response.data.success) {
                    console.log('Passei aqui');
                    setIdUsuario(response.data.user.id);
                } else {
                    console.error('Erro na resposta:', response.data);
                }
            } catch (error) {
                console.error('Erro ao buscar dados do usuário:', error);
            }
        };

        buscarDadosUsuario();
    }, []);

    const handleImageChange = (index, e) => {
        const files = Array.from(e.target.files); // Converte os arquivos em array

        setProduto((prevProduto) => {
            const updatedVariacoes = prevProduto.variacoes.map((variacao, idx) => {
                if (idx === index) {
                    const novasImagens = [...variacao.imagens];
                    files.forEach((file) => {
                        // Só adiciona a imagem se ela não estiver já na lista
                        if (!novasImagens.some(img => img.name === file.name)) {
                            novasImagens.push(file);
                        }
                    });

                    return {
                        ...variacao,
                        imagens: novasImagens
                    };
                }
                return variacao;
            });

            return { ...prevProduto, variacoes: updatedVariacoes }; // Retorna o novo estado com as imagens atualizadas
        });
    };

    const normalizeNumber = (str) => {
        const s = (str || "").toString().replace(',', '.').trim();
        const n = parseFloat(s);
        return isNaN(n) ? "0.00" : n.toFixed(2);
    };


    const handleDrop = (e, index) => {
        e.preventDefault();

        const files = Array.from(e.dataTransfer.files);
        if (files.length > 0) {
            const updatedVariacoes = [...produto.variacoes];

            // Verifica se a imagem ainda não existe para evitar duplicações
            if (!updatedVariacoes[index].imagens.some(img => img.name === files[0].name)) {
                updatedVariacoes[index].imagens.push(files[0]);
                setProduto({ ...produto, variacoes: updatedVariacoes });
            }
        }
    };

    // Reordena as imagens na variação com base no índice de destino
    const handleImageDrop = (index, targetIndex) => {
        if (draggedImage === null) return;

        const updatedVariacoes = [...produto.variacoes];
        const imagens = [...updatedVariacoes[index].imagens];

        const [movedImage] = imagens.splice(draggedImage, 1);
        imagens.splice(targetIndex, 0, movedImage);

        updatedVariacoes[index].imagens = imagens;
        setProduto({ ...produto, variacoes: updatedVariacoes });

        // Reset do índice da imagem arrastada
        setDraggedImage(null);
    };


    const handleKeyDown = (e) => {
        if (e.ctrlKey && e.key === 'e') {
            e.preventDefault(); // Impede qualquer ação padrão ao pressionar Ctrl + E

            setProduto({
                nome: 'Produto Exemplo',
                descricao: 'Descrição do produto',
                descricaoLonga: 'Descrição longa do produto',
                codigoBarras: '1234567890123',
                marca: 'Marca Exemplo',
                idCategoria: '1',
                idFornecedor: '1',
                status: 'Ativo',
                variacoes: [{
                    tamanho: 'M',
                    cor: 'Azul',
                    material: 'Algodão',
                    preco_compra: 30.00,
                    preco_varejo: 60.00,
                    preco_atacado: 50.00,
                    estoque: 100,
                    sku: 'SKU123',
                    peso: 1,
                    largura: 10,
                    altura: 10,
                    profundidade: 10,
                    imagens: []
                }]
            });
        }
    };

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const [categorias, setCategorias] = useState([]);
    const [fornecedores, setFornecedores] = useState([]);

    useEffect(() => {
        const carregarDados = async () => {
            try {
                const categoriasResponse = await api.get('/listarcategorias');
                console.log(categoriasResponse.data.categorias);
                setCategorias(categoriasResponse.data.categorias);

                const fornecedoresResponse = await api.get('/listarfornecedores');
                setFornecedores(fornecedoresResponse.data.fornecedores || []);
            } catch (error) {
                console.error('Erro ao carregar categorias ou fornecedores:', error.response?.data || error.message);
            }
        };

        carregarDados();
    }, []);
    const handleAddVariation = () => {
        setProduto(prev => ({
            ...prev,
            variacoes: [...prev.variacoes, {
                tamanho: '', cor: '', material: '', tipo: '', unidades_por_pacote: 1, preco_compra: '', preco_varejo: '', preco_atacado: '', estoque: '', sku: '', peso: '', dimensoes: '', imagens: []
            }]
        }));
    };

    const handleRemoveVariação = (index) => {
        if (index === 0) {
            alert('Você não pode excluir a variação principal (que é o produto).', 'error');
            return;
        }

        const novasVariações = produto.variacoes.filter((_, i) => i !== index);
        setProduto((prevState) => ({
            ...prevState,
            variacoes: novasVariações,
        }));
    };

    const handleAddVariação = () => {
        const novaVariação = {
            tamanho: '',
            cor: '',
            material: '',
            tipo: '',
            unidades_por_pacote: 1,
            preco_compra: '',
            preco_varejo: '',
            preco_atacado: '',
            estoque: '',
            sku: '',
            peso: '',
            altura: '',
            largura: '',
            profundidade: '',
            imagens: [],
        };
        setProduto((prevState) => ({
            ...prevState,
            variacoes: [...prevState.variacoes, novaVariação],
        }));
    };

    const handleRemoveImage = (index, imageIndex) => {
        const newVariacoes = [...produto.variacoes];
        newVariacoes[index].imagens = newVariacoes[index].imagens.filter((_, i) => i !== imageIndex);
        setProduto({ ...produto, variacoes: newVariacoes });
    };

    function parseCurrency(value) {
        if (!value) return 0;
        return parseFloat(value.replace(/\./g, '').replace(',', '.'));
    }

    const defaultImagePath = '/assets/image/SemImagem.jpg';
    let defaultImageFileCache = null;

    const getDefaultImageFile = async () => {
        if (defaultImageFileCache) return defaultImageFileCache;
        const response = await fetch(defaultImagePath);
        const blob = await response.blob();
        defaultImageFileCache = new File([blob], 'SemImagem.jpg', { type: blob.type || 'image/jpeg' });
        return defaultImageFileCache;
    };

    const ensureVariationsWithDefaultImage = async (variacoes = []) => {
        const defaultFile = await getDefaultImageFile();
        return variacoes.map((variacao) => {
            const imagens = Array.isArray(variacao.imagens) ? variacao.imagens : [];
            if (imagens.length > 0) return variacao;
            return { ...variacao, imagens: [defaultFile] };
        });
    };

    const handleSubmit = async (e, isDraft = false) => {
        e.preventDefault();
        if (!isDraft) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        setLoading(true);
        try {
            const camposFaltando = [];
            if (!produto.nome?.trim()) camposFaltando.push('Nome');
            if (!produto.descricao?.trim()) camposFaltando.push('Descrição curta');
            if (!produto.descricaoLonga?.trim()) camposFaltando.push('Descrição longa');
            if (!produto.codigoBarras?.trim()) camposFaltando.push('Código de barras');
            if (!produto.marca?.trim()) camposFaltando.push('Marca');
            if (!produto.idCategoria) camposFaltando.push('Categoria');
            if (!produto.idFornecedor) camposFaltando.push('Fornecedor');

            if (!isDraft && camposFaltando.length > 0) {
                setTexto(`Preencha os campos obrigatórios: ${camposFaltando.join(', ')}.`);
                abrirModalAviso();
                setLoading(false);
                return;
            }

            const variacaoInvalida = produto.variacoes.findIndex((variacao) => {
                const unidades = parseInt(variacao.unidades_por_pacote, 10);
                return isNaN(unidades) || unidades <= 0;
            });
            if (variacaoInvalida >= 0) {
                setTexto(`Unidades por pacote é obrigatório na variação ${variacaoInvalida + 1}.`);
                abrirModalAviso();
                setLoading(false);
                return;
            }
            const variacoesComImagem = await ensureVariationsWithDefaultImage(produto.variacoes);
            const formData = new FormData();

            console.log("Adicionando informações do produto:", produto);
            formData.append('nome', produto.nome);
            formData.append('descricao', produto.descricao);
            formData.append('descricao_longa', produto.descricaoLonga);
            formData.append('codigo_barras', produto.codigoBarras);
            formData.append('marca', produto.marca);
            formData.append('status', isDraft ? 'rascunho' : produto.status);
            formData.append('id_categoria', produto.idCategoria);
            formData.append('id_fornecedor', produto.idFornecedor);

            variacoesComImagem.forEach((variacao, index) => {
                console.log(`Adicionando variação ${index}:`, variacao);
                formData.append(`variacoes[${index}][tamanho]`, variacao.tamanho);
                formData.append(`variacoes[${index}][cor]`, variacao.cor);
                formData.append(`variacoes[${index}][material]`, variacao.material);
                formData.append(`variacoes[${index}][tipo]`, variacao.tipo || '');
                formData.append(`variacoes[${index}][unidades_por_pacote]`, parseInt(variacao.unidades_por_pacote, 10) || 0);
                formData.append(`variacoes[${index}][preco_compra]`, normalizeNumber(variacao.preco_compra));
                formData.append(`variacoes[${index}][preco_varejo]`, normalizeNumber(variacao.preco_varejo));
                formData.append(`variacoes[${index}][preco_atacado]`, normalizeNumber(variacao.preco_atacado));
                formData.append(`variacoes[${index}][estoque]`, Number(variacao.estoque) || 0);
                formData.append(`variacoes[${index}][sku]`, variacao.sku);
                formData.append(`variacoes[${index}][peso]`, normalizeNumber(variacao.peso));
                formData.append(`variacoes[${index}][altura]`, normalizeNumber(variacao.altura));
                formData.append(`variacoes[${index}][largura]`, normalizeNumber(variacao.largura));
                formData.append(`variacoes[${index}][profundidade]`, normalizeNumber(variacao.profundidade));

                variacao.imagens.forEach((imagem, imageIndex) => {
                    if (imagem instanceof File) {
                        console.log(`Adicionando imagem ${imageIndex} para variação ${index}:`, imagem);
                        formData.append(`variacoes[${index}][imagens][${imageIndex}]`, imagem);
                    }
                });
            });

            console.log("Dados enviados para o back-end:", formData);


            const response = await api.post('/produtos', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            console.log('Produto cadastrado com sucesso:', response.data);
            showToast(isDraft ? 'Produto salvo como rascunho!' : 'Produto cadastrado com sucesso!', 'success');
            navigate('/menu/produtos_e_estoque');
        } catch (error) {
            console.error('Erro ao cadastrar produto:', error.response ? error.response.data : error.message);
            const mensagemErro = error.response?.data?.message
                ? `Nao foi possivel cadastrar o produto. ${error.response.data.message}`
                : 'Nao foi possivel cadastrar o produto. Verifique os campos obrigatorios, categoria e fornecedor.';
            showToast(mensagemErro, 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className='container-principal-produtosEestoque'>

            <dialog id='CaixaDeDialogoAviso' className={modalAbertoAviso ? 'open' : ''}>
                <div className='conteudo-dialog'>
                    <div className='dialog-texto'>
                        <p>{texto}</p>
                        <button id='botao' onClick={fecharModalAviso}>
                            Ok
                        </button>
                    </div>
                </div>
            </dialog>

            <dialog id='CaixaModalCategoria' className={modalCategoriaAberto ? 'open' : ''}>
                <div className='conteudo-dialog alterar-dados'>
                    <div className='dialog-texto'>
                        <h2>Adicionar Categoria</h2>
                        <form className='form-alterar-dados' onSubmit={salvarCategoria}>
                            <label>Nome da Categoria: <span className="span-obrigatorio">*</span></label>
                            <div className="input-nome">
                                <input
                                    type="text"
                                    value={novaCategoria.nome}
                                    onChange={(e) => setNovaCategoria({ ...novaCategoria, nome: e.target.value })}
                                    placeholder="Digite o nome da categoria"
                                    required
                                />
                            </div>

                            <label>Descrição:</label>
                            <div className="input-descricao">
                                <textarea
                                    value={novaCategoria.descricao}
                                    onChange={(e) => setNovaCategoria({ ...novaCategoria, descricao: e.target.value })}
                                    placeholder="Digite a descrição (opcional)"
                                    rows="3"
                                />
                            </div>

                            <label>Categoria Raiz (Pai):</label>
                            <div className="input-categoria-pai">
                                <select
                                    value={novaCategoria.id_categoria_pai}
                                    onChange={(e) => setNovaCategoria({ ...novaCategoria, id_categoria_pai: e.target.value })}
                                >
                                    <option value="">Nenhuma (Categoria Principal)</option>
                                    {categorias && Array.isArray(categorias) && categorias.map((categoria) => (
                                        <option key={categoria.id} value={categoria.id}>
                                            {categoria.nome}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className='bnts-decisao'>
                                <button type='submit' className='bnt-sim'>
                                    Salvar
                                </button>
                                <button type='button' className='bnt-nao' onClick={fecharModalCategoria}>
                                    Cancelar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </dialog>

            <dialog id='CaixaModalFornecedor' className={modalFornecedorAberto ? 'open' : ''}>
                <div className='conteudo-dialog alterar-dados'>
                    <div className='dialog-texto'>
                        <h2>Adicionar Fornecedor</h2>
                        <form className='form-alterar-dados' onSubmit={salvarFornecedor}>
                            <label>Nome do Fornecedor: <span className="span-obrigatorio">*</span></label>
                            <div className="input-nome">
                                <input
                                    type="text"
                                    value={novoFornecedor.nome}
                                    onChange={(e) => setNovoFornecedor({ ...novoFornecedor, nome: e.target.value })}
                                    placeholder="Digite o nome do fornecedor"
                                    required
                                />
                            </div>

                            <label>CNPJ: <span className="span-obrigatorio">*</span></label>
                            <div className="input-cnpj">
                                <input
                                    type="text"
                                    value={novoFornecedor.cnpj}
                                    onChange={(e) => setNovoFornecedor({ ...novoFornecedor, cnpj: formatarCNPJ(e.target.value) })}
                                    placeholder="00.000.000/0000-00"
                                    maxLength="18"
                                    required
                                />
                            </div>

                            <label>Telefone:</label>
                            <div className="input-telefone">
                                <input
                                    type="text"
                                    value={novoFornecedor.telefone}
                                    onChange={(e) => setNovoFornecedor({ ...novoFornecedor, telefone: formatarTelefone(e.target.value) })}
                                    placeholder="(00) 00000-0000"
                                    maxLength="15"
                                />
                            </div>

                            <label>E-mail: <span className="span-obrigatorio">*</span></label>
                            <div className="input-email">
                                <input
                                    type="email"
                                    value={novoFornecedor.email}
                                    onChange={(e) => setNovoFornecedor({ ...novoFornecedor, email: e.target.value })}
                                    placeholder="email@exemplo.com"
                                    required
                                />
                            </div>

                            <label>Site:</label>
                            <div className="input-site">
                                <input
                                    type="text"
                                    value={novoFornecedor.site}
                                    onChange={(e) => setNovoFornecedor({ ...novoFornecedor, site: e.target.value })}
                                    placeholder="https://www.exemplo.com"
                                />
                            </div>

                            <label>Nome do Contato:</label>
                            <div className="input-contato-nome">
                                <input
                                    type="text"
                                    value={novoFornecedor.contato_nome}
                                    onChange={(e) => setNovoFornecedor({ ...novoFornecedor, contato_nome: e.target.value })}
                                    placeholder="Nome do contato"
                                />
                            </div>

                            <label>E-mail do Contato:</label>
                            <div className="input-contato-email">
                                <input
                                    type="email"
                                    value={novoFornecedor.contato_email}
                                    onChange={(e) => setNovoFornecedor({ ...novoFornecedor, contato_email: e.target.value })}
                                    placeholder="contato@exemplo.com"
                                />
                            </div>

                            <label>CEP: <span className="span-obrigatorio">*</span></label>
                            <div className="input-cep">
                                <input
                                    type="text"
                                    value={novoFornecedor.cep}
                                    onChange={(e) => {
                                        const cepFormatado = formatarCEP(e.target.value);
                                        setNovoFornecedor({ ...novoFornecedor, cep: cepFormatado });
                                        if (cepFormatado.replace(/\D/g, '').length === 8) {
                                            buscarEnderecoPorCep(cepFormatado);
                                        }
                                    }}
                                    placeholder="00000-000"
                                    maxLength="9"
                                    required
                                />
                            </div>

                            <label>Logradouro:</label>
                            <div className="input-logradouro">
                                <input
                                    type="text"
                                    value={novoFornecedor.logradouro}
                                    onChange={(e) => setNovoFornecedor({ ...novoFornecedor, logradouro: e.target.value })}
                                    placeholder="Rua, Avenida..."
                                    disabled
                                />
                            </div>

                            <label>Número:</label>
                            <div className="input-numero">
                                <input
                                    type="text"
                                    value={novoFornecedor.numero}
                                    onChange={(e) => setNovoFornecedor({ ...novoFornecedor, numero: e.target.value })}
                                    placeholder="Nº"
                                />
                            </div>

                            <label>Complemento:</label>
                            <div className="input-complemento">
                                <input
                                    type="text"
                                    value={novoFornecedor.complemento}
                                    onChange={(e) => setNovoFornecedor({ ...novoFornecedor, complemento: e.target.value })}
                                    placeholder="Apto, Sala..."
                                />
                            </div>

                            <label>Bairro:</label>
                            <div className="input-bairro">
                                <input
                                    type="text"
                                    value={novoFornecedor.bairro}
                                    onChange={(e) => setNovoFornecedor({ ...novoFornecedor, bairro: e.target.value })}
                                    placeholder="Bairro"
                                    disabled
                                />
                            </div>

                            <label>Cidade:</label>
                            <div className="input-cidade">
                                <input
                                    type="text"
                                    value={novoFornecedor.cidade}
                                    onChange={(e) => setNovoFornecedor({ ...novoFornecedor, cidade: e.target.value })}
                                    placeholder="Cidade"
                                    disabled
                                />
                            </div>

                            <label>Estado:</label>
                            <div className="input-estado">
                                <input
                                    type="text"
                                    value={novoFornecedor.estado}
                                    onChange={(e) => setNovoFornecedor({ ...novoFornecedor, estado: e.target.value.toUpperCase() })}
                                    placeholder="UF"
                                    maxLength="2"
                                    disabled
                                />
                            </div>

                            <div className='bnts-decisao'>
                                <button type='submit' className='bnt-sim'>
                                    Salvar
                                </button>
                                <button type='button' className='bnt-nao' onClick={fecharModalFornecedor}>
                                    Cancelar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </dialog>

            <Cabecalho />
            <CookieAceite />
            <main className='main-cadastroProduto'>
                <MenuLateral />
                <section className='conteudo-produtosEestoque'>
                    <div className='titulo-produtosEestoque'>
                        <h1><span>Produtos e Estoque</span> &gt; Cadastro de Produto</h1>
                    </div>
                    <BtnVoltar />
                    {loading ? (
                        <div className='loading'>
                            <svg xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 24 24'><path fill='#131C46' d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z' opacity='0.25' /><path fill='#131C46' d='M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z'><animateTransform attributeName='transform' dur='0.75s' repeatCount='indefinite' type='rotate' values='0 12 12;360 12 12' /></path></svg>
                            <h2>Enviando dados do produto...</h2>
                        </div>
                    ) : (
                        <div className='perfil-cadastro-produtosEestoque'>
                            <h2>Digite os dados do produto</h2>
                            <form onSubmit={handleSubmit}>
                                {/* Campos principais do Produto */}
                                <label htmlFor="nome">Nome: <span className='span-obrigatorio'>*</span></label>
                                <div className="input-nome">
                                    <input
                                        id="nome"
                                        value={produto.nome}
                                        onChange={(e) => setProduto({ ...produto, nome: e.target.value })}
                                        type="text"
                                        placeholder="Digite o nome do produto"
                                        minLength="3" // Nome com no mínimo 3 caracteres
                                        maxLength="100" // Limite para evitar nomes muito longos
                                        className="input-field"
                                    />
                                </div>

                                {/* Descrição */}
                                <label htmlFor="descricao">Descrição: <span className='span-obrigatorio'>*</span></label>
                                <div className="input-descricao">
                                    <textarea
                                        id="descricao"
                                        value={produto.descricao}
                                        onChange={(e) => setProduto({ ...produto, descricao: e.target.value })}
                                        placeholder="Digite uma breve descrição"
                                        maxLength="250" // Limite de caracteres
                                        rows="3"
                                        className="textarea-field"
                                    />
                                </div>

                                {/* Descrição Longa */}
                                <label htmlFor="descricaoLonga">Descrição Longa: <span className='span-obrigatorio'>*</span></label>
                                <div className="input-descricaoLonga">
                                    <textarea
                                        id="descricaoLonga"
                                        value={produto.descricaoLonga}
                                        onChange={(e) => setProduto({ ...produto, descricaoLonga: e.target.value })}
                                        placeholder="Digite uma descrição detalhada (aceita quebras de linha, emojis e HTML simples como <span style='color:#131C46; font-size:18px'>texto</span>)"
                                        rows="6"
                                        className="textarea-field"
                                    />
                                </div>
                                <small className='descricao-longa-hint'>Suporta quebras de linha, emojis e HTML simples: span, p, br, ul, ol, li, strong, em (apenas color e font-size no style).</small>

                                {/* Código de Barras */}
                                <label htmlFor="codigoBarras">Código de Barras (EAN/UPC): <span className='span-obrigatorio'>*</span></label>
                                <div className="input-codigoBarras">
                                    <input
                                        id="codigoBarras"
                                        value={produto.codigoBarras}
                                        onChange={(e) => setProduto({ ...produto, codigoBarras: e.target.value })}
                                        type="text"
                                        placeholder="Digite o código de barras"
                                        maxLength="13"
                                        pattern="\d{8}|\d{12}|\d{13}" // Aceita EAN-8, EAN-13 ou UPC-A
                                        title="Digite um código válido com 8, 12 ou 13 dígitos"
                                        className="input-field"
                                    />
                                </div>

                                {/* Marca */}
                                <label htmlFor="marca">Marca: <span className='span-obrigatorio'>*</span></label>
                                <div className="input-marca">
                                    <input
                                        id="marca"
                                        value={produto.marca}
                                        onChange={(e) => setProduto({ ...produto, marca: e.target.value })}
                                        type="text"
                                        placeholder="Digite a marca do produto"
                                        className="input-field"
                                    />
                                </div>

                                {/* Status */}
                                <label htmlFor="status">Status: <span className='span-obrigatorio'>*</span></label>
                                <div className="input-status">
                                    <select
                                        id="status"
                                        value={produto.status}
                                        onChange={(e) => setProduto({ ...produto, status: e.target.value })}
                                        className="select-field"
                                    >
                                        <option value="ativo">Ativo</option>
                                        <option value="inativo">Inativo</option>
                                    </select>
                                </div>

                                {/* Categoria */}
                                <label htmlFor="categoria">Categoria: <span className='span-obrigatorio'>*</span></label>
                                <div className="input-categoria">
                                    <select
                                        id="categoria"
                                        value={produto.idCategoria}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value;
                                            if (selectedValue === 'add-categoria') {
                                                abrirModalCategoria();
                                            } else {
                                                setProduto({ ...produto, idCategoria: selectedValue });
                                            }
                                        }}
                                        className="select-field"
                                    >
                                        <option value="">Selecione uma Categoria</option>
                                        {categorias && Array.isArray(categorias) && categorias.map((categoria) => (
                                            <option key={categoria.id} value={categoria.id}>
                                                {categoria.nome}
                                            </option>
                                        ))}
                                        {/* Opção para adicionar nova categoria */}
                                        <option value="add-categoria">+ Adicionar Categoria</option>
                                    </select>
                                </div>

                                {/* Fornecedor */}
                                <label htmlFor="fornecedor">Fornecedor: <span className='span-obrigatorio'>*</span></label>
                                <div className="input-fornecedor">
                                    <select
                                        id="fornecedor"
                                        value={produto.idFornecedor}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value;
                                            if (selectedValue === 'add-fornecedor') {
                                                abrirModalFornecedor();
                                            } else {
                                                setProduto({ ...produto, idFornecedor: selectedValue });
                                            }
                                        }}
                                        className="select-field"
                                    >
                                        <option value="">Selecione um Fornecedor</option>
                                        {fornecedores && Array.isArray(fornecedores) && fornecedores.map((fornecedor) => (
                                            <option key={fornecedor.id} value={fornecedor.id}>
                                                {fornecedor.nome}
                                            </option>
                                        ))}
                                        {/* Opção para adicionar novo fornecedor */}
                                        <option value="add-fornecedor">+ Adicionar Fornecedor</option>
                                    </select>
                                </div>

                                {/* Variações */}
                                {produto.variacoes.map((variacao, index) => (
                                    <div key={index}>
                                        <div className="variacao-header">
                                            {index !== 0 && (
                                                <>
                                                    <h3 className="variacao-titulo">
                                                        {`Variação ${index}`}
                                                    </h3>
                                                    <button
                                                        className="bnt-excluirVariacao"
                                                        onClick={() => handleRemoveVariação(index)}
                                                        disabled={index === 0 || produto.variacoes.length === 1}
                                                        style={{ display: produto.variacoes.length === 1 && index === 0 ? 'none' : 'flex' }}
                                                    >
                                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M11.6666 9.16667V14.1667M8.33325 9.16667V14.1667M4.99992 5.83333V15.8333C4.99992 16.2754 5.17551 16.6993 5.48807 17.0118C5.80063 17.3244 6.22456 17.5 6.66659 17.5H13.3333C13.7753 17.5 14.1992 17.3244 14.5118 17.0118C14.8243 16.6993 14.9999 16.2754 14.9999 15.8333V5.83333M3.33325 5.83333H16.6666M5.83325 5.83333L7.49992 2.5H12.4999L14.1666 5.83333" stroke-width="2.08333" stroke-linecap="round" stroke-linejoin="round" />
                                                        </svg>

                                                        <p>Remover</p>
                                                    </button>
                                                </>
                                            )}
                                        </div>
                                        {/* Campo Tamanho */}
                                        <label>Tamanho:</label>
                                        <div className="input-tamanho">
                                            <input
                                                value={variacao.tamanho}
                                                onChange={(e) => {
                                                    const newVariacoes = [...produto.variacoes];
                                                    newVariacoes[index].tamanho = e.target.value;
                                                    setProduto({ ...produto, variacoes: newVariacoes });
                                                }}
                                                type="text"
                                                placeholder='Digite o tamanho (Opcional)'
                                            />
                                        </div>

                                        {/* Campo Cor */}
                                        <label>Cor:</label>
                                        <div className="input-cor">
                                            <input
                                                value={variacao.cor}
                                                onChange={(e) => {
                                                    const newVariacoes = [...produto.variacoes];
                                                    newVariacoes[index].cor = e.target.value;
                                                    setProduto({ ...produto, variacoes: newVariacoes });
                                                }}
                                                type="text"
                                                placeholder='Digite a cor (Opcional)'
                                            />
                                        </div>

                                        {/* Campo Material */}
                                        <label>Material:</label>
                                        <div className="input-material">
                                            <input
                                                value={variacao.material}
                                                onChange={(e) => {
                                                    const newVariacoes = [...produto.variacoes];
                                                    newVariacoes[index].material = e.target.value;
                                                    setProduto({ ...produto, variacoes: newVariacoes });
                                                }}
                                                type="text"
                                                placeholder='Digite o material (Opcional)'
                                            />
                                        </div>

                                        {/* Campo Tipo */}
                                        <label>Tipo:</label>
                                        <div className="input-tipo">
                                            <input
                                                value={variacao.tipo || ''}
                                                onChange={(e) => {
                                                    const newVariacoes = [...produto.variacoes];
                                                    newVariacoes[index].tipo = e.target.value;
                                                    setProduto({ ...produto, variacoes: newVariacoes });
                                                }}
                                                type="text"
                                                placeholder='Digite o tipo (Opcional)'
                                            />
                                        </div>

                                        {/* Campos com restrições específicas */}

                                        {/* Preço de Compra */}
                                        <label>Preço de Compra: <span className='span-obrigatorio'>*</span></label>
                                        <div className="input-precoCompra">
                                            <CurrencyInput
                                                prefix="R$ "
                                                decimalSeparator=","
                                                groupSeparator="."
                                                decimalsLimit={2}
                                                allowNegativeValue={false}
                                                placeholder="R$ 0,00"
                                                value={produto.variacoes[index].preco_compra}
                                                onValueChange={(value) => {
                                                    const newVariacoes = [...produto.variacoes];
                                                    newVariacoes[index].preco_compra = value;
                                                    setProduto({ ...produto, variacoes: newVariacoes });
                                                }}
                                            />
                                        </div>

                                        {/* Preço de Varejo */}
                                        <label>Preço de Varejo: <span className='span-obrigatorio'>*</span></label>
                                        <div className="input-precoVarejo">
                                            <CurrencyInput
                                                prefix="R$ "
                                                decimalSeparator=","
                                                groupSeparator="."
                                                decimalsLimit={2}
                                                allowNegativeValue={false}
                                                placeholder="R$ 0,00"
                                                value={produto.variacoes[index].preco_varejo}
                                                onValueChange={(value) => {
                                                    const newVariacoes = [...produto.variacoes];
                                                    newVariacoes[index].preco_varejo = value;
                                                    setProduto({ ...produto, variacoes: newVariacoes });
                                                }}
                                            />
                                        </div>

                                        {/* Preço de Atacado */}
                                        <label>Preço de Atacado: <span className='span-obrigatorio'>*</span></label>
                                        <div className="input-precoAtacado">
                                            <CurrencyInput
                                                prefix="R$ "
                                                decimalSeparator=","
                                                groupSeparator="."
                                                decimalsLimit={2}
                                                allowNegativeValue={false}
                                                placeholder="R$ 0,00"
                                                value={produto.variacoes[index].preco_atacado}
                                                onValueChange={(value) => {
                                                    const newVariacoes = [...produto.variacoes];
                                                    newVariacoes[index].preco_atacado = value;
                                                    setProduto({ ...produto, variacoes: newVariacoes });
                                                }}
                                            />
                                        </div>

                                        {/* Estoque */}
                                        <label>Estoque: <span className='span-obrigatorio'>*</span></label>
                                        <div className="input-estoque">
                                            <input
                                                value={variacao.estoque}
                                                onChange={(e) => {
                                                    const newVariacoes = [...produto.variacoes];
                                                    newVariacoes[index].estoque = e.target.value;
                                                    setProduto({ ...produto, variacoes: newVariacoes });
                                                }}
                                                type='number'
                                                min="0"
                                                placeholder='Digite a quantidade de estoque'
                                            />
                                        </div>

                                        {/* Unidades por pacote */}
                                        <label>Unidades por pacote: <span className='span-obrigatorio'>*</span></label>
                                        <div className="input-unidades-por-pacote">
                                            <input
                                                value={variacao.unidades_por_pacote ?? ''}
                                                onChange={(e) => {
                                                    const newVariacoes = [...produto.variacoes];
                                                    newVariacoes[index].unidades_por_pacote = e.target.value;
                                                    setProduto({ ...produto, variacoes: newVariacoes });
                                                }}
                                                type='number'
                                                min="1"
                                                placeholder='Digite as unidades por pacote'
                                            />
                                        </div>

                                        {/* SKU */}
                                        <label>SKU:</label>
                                        <div className="input-sku">
                                            <input
                                                value={variacao.sku}
                                                onChange={(e) => {
                                                    const newVariacoes = [...produto.variacoes];
                                                    newVariacoes[index].sku = e.target.value;
                                                    setProduto({ ...produto, variacoes: newVariacoes });
                                                }}
                                                type="text"
                                                placeholder='Digite o SKU (Opcional)'
                                            />
                                        </div>

                                        {/* Peso */}
                                        <label>Peso: <span className='span-obrigatorio'>*</span></label>
                                        <div className="input-peso">
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    placeholder="Digite o peso do produto"
                                                    value={variacao.peso || ''}
                                                    onChange={(e) => {
                                                        const newVariacoes = [...produto.variacoes];
                                                        const inputValue = e.target.value;

                                                        // Atualiza o valor do peso inputado
                                                        newVariacoes[index].peso = inputValue;

                                                        // Realiza a conversão para gramas ou kg com base na unidade selecionada
                                                        const pesoEmGramas = newVariacoes[index].unidadePeso === 'kg'
                                                            ? inputValue * 1000  // Converte kg para g
                                                            : inputValue;        // Mantém o valor em g

                                                        // Atualiza o campo 'peso' com o valor convertido
                                                        newVariacoes[index].peso = pesoEmGramas;

                                                        setProduto({ ...produto, variacoes: newVariacoes });
                                                    }}
                                                />

                                                <select
                                                    value={variacao.unidadePeso || 'g'}
                                                    onChange={(e) => {
                                                        const newVariacoes = [...produto.variacoes];
                                                        const unidadeSelecionada = e.target.value;

                                                        // Atualiza a unidade selecionada
                                                        newVariacoes[index].unidadePeso = unidadeSelecionada;

                                                        // Realiza a conversão para gramas ou kg com base na unidade selecionada
                                                        const pesoEmGramas = unidadeSelecionada === 'kg'
                                                            ? (variacao.peso || 0) * 1000  // Converte kg para g
                                                            : (variacao.peso || 0);         // Mantém o valor em g

                                                        // Atualiza o campo 'peso' com o valor convertido
                                                        newVariacoes[index].peso = pesoEmGramas;

                                                        setProduto({ ...produto, variacoes: newVariacoes });
                                                    }}
                                                    style={{ marginLeft: '8px' }}
                                                >
                                                    <option value="g">g</option>
                                                    <option value="kg">kg</option>
                                                </select>
                                            </div>
                                        </div>


                                        {/* Dimensões (A x L x P) */}
                                        <label>Dimensões (A x L x P): <span className='span-obrigatorio'>*</span></label>
                                        <div className="input-dimensoes">
                                            <input
                                                value={produto.variacoes[index].altura || ''}  // Corrigido para usar o estado correto
                                                onChange={(e) => {
                                                    const newVariacoes = [...produto.variacoes];
                                                    newVariacoes[index].altura = e.target.value;
                                                    setProduto({ ...produto, variacoes: newVariacoes });
                                                }}
                                                type="number"
                                                min="0"
                                                placeholder="A (cm)"
                                            />
                                            <p>X</p>
                                            <input
                                                value={produto.variacoes[index].largura || ''}
                                                onChange={(e) => {
                                                    const newVariacoes = [...produto.variacoes];
                                                    newVariacoes[index].largura = e.target.value;
                                                    setProduto({ ...produto, variacoes: newVariacoes });
                                                }}
                                                type="number"
                                                min="0"
                                                placeholder="L (cm)"
                                            />
                                            <p>X</p>
                                            <input
                                                value={produto.variacoes[index].profundidade || ''}
                                                onChange={(e) => {
                                                    const newVariacoes = [...produto.variacoes];
                                                    newVariacoes[index].profundidade = e.target.value;
                                                    setProduto({ ...produto, variacoes: newVariacoes });
                                                }}
                                                type="number"
                                                min="0"
                                                placeholder="P (cm)"
                                            />
                                        </div>

                                        <label>Imagens: <span className='span-obrigatorio'>*</span></label>
                                        <div className="input-imagens">
                                            <div
                                                className="image-preview"
                                                onDragOver={(e) => e.preventDefault()}
                                                onDrop={(e) => handleDrop(e, index)}
                                            >
                                                {variacao.imagens.map((imagem, imageIndex) => (
                                                    <div
                                                        className="image-item"
                                                        key={`${index}-${imageIndex}`}
                                                        draggable
                                                        onDragStart={() => setDraggedImage(imageIndex)}
                                                        onDragOver={(e) => e.preventDefault()}
                                                        onDrop={() => handleImageDrop(index, imageIndex)}
                                                    >
                                                        <img src={URL.createObjectURL(imagem)} alt={`Imagem ${imageIndex + 1}`} />
                                                        <button
                                                            type="button"
                                                            className="remove-button"
                                                            onClick={() => handleRemoveImage(index, imageIndex)}
                                                        >
                                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M11.6666 9.16667V14.1667M8.33325 9.16667V14.1667M4.99992 5.83333V15.8333C4.99992 16.2754 5.17551 16.6993 5.48807 17.0118C5.80063 17.3244 6.22456 17.5 6.66659 17.5H13.3333C13.7753 17.5 14.1992 17.3244 14.5118 17.0118C14.8243 16.6993 14.9999 16.2754 14.9999 15.8333V5.83333M3.33325 5.83333H16.6666M5.83325 5.83333L7.49992 2.5H12.4999L14.1666 5.83333" stroke-width="2.08333" stroke-linecap="round" stroke-linejoin="round" /> </svg>
                                                        </button>
                                                    </div>
                                                ))}

                                                <div
                                                    className="upload-box"
                                                    onClick={() => document.getElementById(`upload-${index}`).click()}
                                                >
                                                    <span>+</span>
                                                    <input
                                                        name={`upload-${index}`}
                                                        id={`upload-${index}`}
                                                        type="file"
                                                        multiple
                                                        onChange={(e) => handleImageChange(index, e)}
                                                        style={{ display: 'none' }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                <button type="button" className='bnt-addVariacao' onClick={handleAddVariation}>+ Adicionar Variação</button>
                                <div className='botoes-salvar-container'>
                                    <button type="button" className='bnt-salvarRascunho' onClick={(e) => handleSubmit(e, true)}>Salvar como Rascunho</button>
                                    <button type="submit" className='bnt-cadastroProduto' onClick={(e) => handleSubmit(e, false)}>Cadastrar Produto</button>
                                </div>
                            </form>
                        </div>
                    )}
                </section>
            </main>
            <Rodape />

        </section>
    );
}